import { MutationTree } from 'vuex';

export default <MutationTree<webparts.state.WebpartsState>>{};
